import React, { Fragment } from 'react'
import type { FC } from 'react'
import { routesConfigs } from '@/checkout-instore-legacy/routes'
import AppContainer from '@/checkout-instore-legacy/components/AppContainer'
import { NewSaleModalDialog } from '@/checkout-instore-legacy/share/components/NewSaleModalDialog'
import { useParams } from 'react-router'
import { without } from 'ramda'
import { csx } from '@vtex/admin-ui'

import { PrivateRoute } from '../../../screens/Instore/components'
import { checkoutInstoreRoutesMigratedMap } from './migrated'
import { TopbarRightArea } from '../../../screens/Instore/components/Header/Topbar/Topbar'

const routesToImportList = [
  ...routesConfigs.sale,
  ...routesConfigs.orderManagement,
  ...routesConfigs.config,
  ...routesConfigs.returnExchange,
]
  .map((routeConfig) => {
    const routeConfigPath = routeConfig.path.startsWith('/')
      ? routeConfig.path
      : `/${routeConfig.path}`

    return {
      ...routeConfig,
      // react-router 5 identifies optional parameters when they finishes with ?
      // react-router 3 identifier optional parameters when they are wrapped by parenthesis
      // this replace makes the conversion since the checkout-instore uses react-router 3
      path: routeConfigPath.replace(/\((.*?)\)/g, '$1?'),
    }
  })
  .filter((routeConfig) => {
    if (routeConfig.path === '/') {
      return false
    }

    return !checkoutInstoreRoutesMigratedMap[routeConfig.path]
  })

type CheckoutInstoreRouteProps = {
  component: FC<any>
  path: string
}

const CheckoutInstoreRoute: FC<CheckoutInstoreRouteProps> = ({
  component: Component,
}) => {
  const params = useParams<Record<string, string>>()

  return (
    <AppContainer>
      <Component params={params} />
    </AppContainer>
  )
}

export const CheckoutInstoreRoutes: FC = () => {
  return (
    <Fragment>
      {routesToImportList.map((routeToImport) => {
        const exact = without(
          [routeToImport],
          routesToImportList
        ).some((anotherRoute) =>
          anotherRoute.path.startsWith(routeToImport.path)
        )

        return (
          <PrivateRoute
            key={routeToImport.path}
            path={routeToImport.path}
            exact={exact}
          >
            <CheckoutInstoreRoute
              path={routeToImport.path}
              component={routeToImport.component}
            />
            {routeToImport.path === '/payment' && (
              <TopbarRightArea>
                <div className={csx({ float: 'right' })}>
                  <NewSaleModalDialog variant="tertiary" />
                </div>
              </TopbarRightArea>
            )}
          </PrivateRoute>
        )
      })}
    </Fragment>
  )
}
